import React from 'react';

import {
  ICustomRenderCellJSXProps,
  IListViewTableColumns,
  IListViewTableRow,
  RowsPerPage,
} from '~/src/dash/components/tables/ListViewTable/common';
import { useListViewTableStore } from '~/src/dash/components/tables/ListViewTable/context';
import { EllipsisWithTooltipRender } from '~/src/dash/components/tables/ListViewTable/ListViewTableRow/templates';
import { Div, Text } from '~/src/dash/publicaUI';
import { IChannelMappingRow, orderDirection } from '~/src/dash/views/channels/api';

export const formatDataToLVTRows = (
  data: IChannelMappingRow[],
  cfg: IChannelMappingsTable,
): IListViewTableRow[] => {
  const rows = [] as IListViewTableRow[];
  data.forEach((datum) => {
    const row = {} as IListViewTableRow;
    Object.values(cfg.columns).forEach((col) => {
      const { cellJSX, cellRenderType, cellStyle, formatValue, isNumeric, key, responseKey } = col;
      let value: any = datum[responseKey as keyof IChannelMappingRow];
      if (isNumeric) {
        value = value !== null ? Number(value) : null;
      }
      if (formatValue) {
        value = formatValue(value);
      }
      row[key] = {
        value,
        ...(cellJSX ? { jsx: cellJSX } : {}),
        ...(cellRenderType ? { renderType: cellRenderType } : {}),
        ...(cellStyle ? { cellStyle } : {}),
      };
    });
    rows.push(row);
  });
  return rows;
};

// open modal when clicking on SubChannels
const ChannelMappingModalLink = (props: ICustomRenderCellJSXProps) => {
  const { customFunctions } = useListViewTableStore();
  const { value } = props;
  return (
    <Div onClick={() => customFunctions.handleClickOnSubChannels(props.row.SubChannels.value)}>
      <Text small bold>
        {Array.isArray(value) ? value.length : 1}
      </Text>
    </Div>
  );
};

interface IChannelMappingsTable {
  columns: IListViewTableColumns;
}

export interface IChannelMappingsConfig {
  cypressClassName: string;
  defaultState: {
    activeColumnKeys: string[];
    isTableExpanded: boolean;
    orderDirection: orderDirection;
    orderBy: string;
    page: number;
    rowsPerPage: RowsPerPage;
    searchInput: string;
  };
  columnSelector: {
    resetKeys?: string[];
  };
  sorts: string[];
  table: IChannelMappingsTable;
}

export const channelMappingsConfig = {
  cypressClassName: 'channelViewMappings',
  defaultState: {
    activeColumnKeys: ['SubChannels'],
    isTableExpanded: false,
    orderDirection: 'desc',
    orderBy: 'name',
    page: 0,
    rowsPerPage: 25,
    searchInput: '',
  },
  columnSelector: {
    resetKeys: ['SubChannels'],
  },
  sorts: ['SubChannels'],
  table: {
    columns: {
      ID: {
        isHidden: true,
        isSearchable: true,
        key: 'ID',
        label: 'ID',
        requestKey: 'ID',
        responseKey: 'ID',
        valueType: 'string',
      },
      Name: {
        cellJSX: EllipsisWithTooltipRender,
        cellRenderType: 'name_link',
        defaultOrderDirection: 'asc',
        headerRenderType: 'name',
        isSearchable: true,
        key: 'Name',
        label: 'Name',
        requestKey: 'name',
        responseKey: 'Name',
        valueType: 'string',
      },
      SubChannels: {
        cellJSX: ChannelMappingModalLink,
        cellRenderType: 'number',
        headerRenderType: 'number',
        defaultOrderDirection: 'asc',
        isSearchable: true,
        key: 'SubChannels',
        label: 'Sub Channels',
        requestKey: 'sub_sites',
        responseKey: 'SubChannels',
        valueType: 'array',
      },
    },
  },
} as IChannelMappingsConfig;
